/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterLink, RouterView, useRoute } from "vue-router";
import { useLocalization } from "@lemmonhq/uikit";
import { SubpageHeader } from "@app/vue/components/SubpageHeader";
export * from "./Templates/index";
export * from "./Schedule/index";
export * from "./Requests/index";
export * from "./Hours/index";

const TABS = [
  {
    key: "schedule",
    path: "/app/workday/rota/schedule",
    icon: "calendar_view_week",
  },
  { key: "requests", path: "/app/workday/rota/requests", icon: "inbox" },
  { key: "hours", path: "/app/workday/rota/hours", icon: "schedule" },
  {
    key: "templates",
    path: "/app/workday/rota/templates",
    icon: "view_timeline",
  },
];

// The rota: the schedule itself, and the day templates it's built from.
// See docs/plans/workday/staff_planning.md.
export const WorkDayRotaPage = defineComponent({
  name: "WorkDayRotaPage",
  setup() {
    const { t } = useLocalization();
    const route = useRoute();
    return () => (
      <div class="flex h-full w-full flex-col overflow-hidden bg-base-200">
        <SubpageHeader
          title={t("workday.nav.rota")}
          subtitle={t("workday.rota.subtitle")}
        >
          <div role="tablist" class="tabs tabs-boxed bg-base-100">
            {TABS.map((tab) => (
              <RouterLink
                key={tab.key}
                to={tab.path}
                role="tab"
                class={[
                  "tab gap-1",
                  route.path.startsWith(tab.path) ? "tab-active" : "",
                ].join(" ")}
              >
                <span class="material-symbols-outlined text-base">
                  {tab.icon}
                </span>
                {t(`workday.rota.tab_${tab.key}`)}
              </RouterLink>
            ))}
          </div>
        </SubpageHeader>
        <div class="flex-1 space-y-5 overflow-auto p-5">
          <RouterView />
        </div>
      </div>
    );
  },
});
